import Axios from 'axios';

export const getPages = () => Axios.get('Administration/listPagesPermissions');

export const getUsers = () => Axios.get('Administration/listUsers');

export const getGroups = () => Axios.get('Administration/listGroups');

export const getPageStructure = pageName => Axios.post('Administration/ListObjectsPermissions', { pageName });

export const getListPermissionsDefault = () => Axios.get('Administration/ListPermissionsDefault');

export const savePermissionsDefault = params => Axios.put('Administration/SavePermissionsDefault', params);

export const getListPermission = params => Axios.post('Administration/ListPermission', params);

export const getListPermissionUser = params => Axios.post('Administration/ListPermissionUser', params);

export const getListPermissionGroup = params => Axios.post('Administration/ListPermissionGroup', params);

export const applyPermission = params => Axios.put('Administration/ApplyPermission', params);

export const getListUsersPermissions = () => Axios.get('Administration/listUsersPermissions');

export const getListGroupsPermissions = () => Axios.get('Administration/listGroupsPermissions');

export const getListPagesPermissions = () => Axios.get('Administration/listPagesPermissions');

export const getListPermissionMenu = params => Axios.post('Administration/ListPermissionMenu', params);

export const getListUserGroupPermissionMenu = params => Axios.post('Administration/ListUserGroupPermissionMenu', params);

export const applyPermissionMenu = params => Axios.post('Administration/ApplyPermissionMenu', params);

export const getListMenus = () => Axios.get('Administration/ListMenus');

export const getPortalsLinkGroup = params => Axios.post('Administration/PortalsLinkGroup', params);

export const savePostPortalsGroups = params => Axios.post('Administration/PostPortalsGroups', params);
